import React, {Component} from 'react';
import './ProfileGeneral.css';

class ProfileGeneral extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {};

    render() {
        return (
            <div className="row">
                <div className="col-md-8 col-lg-9">
                    <div className="panel">
                        <div className="panel-body">
                            <form>
                                <div className="p-x-1">
                                    <fieldset className="form-group">
                                        <label htmlFor="account-name">ФИО</label>
                                        <input type="text" className="form-control" id="account-name" value="Паллетов Пётр Петрович" />
                                    </fieldset>
                                    <fieldset className="form-group">
                                        <label htmlFor="account-company">Компания</label>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="input-group">
                                                    <input type="text" className="form-control" readOnly={true} value="Не указана"/>
                                                    <div className="input-group-btn">
                                                        <button className="btn btn-primary">Стать поставщиком</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                    <fieldset className="form-group">
                                        <label htmlFor="account-username">
                                            Email&nbsp;&nbsp;&nbsp;&nbsp;
                                            <small className="text-success font-weight-normal"><i className="fa fa-check"/>&nbsp;Подтверждён</small>
                                        </label>
                                        <input type="email" className="form-control" id="account-username" value="supplier@mail.ru" />
                                    </fieldset>
                                    <fieldset className="form-group">
                                        <label htmlFor="account-email">
                                            Номер телефона&nbsp;&nbsp;&nbsp;&nbsp;
                                            <small className="text-warning font-weight-normal"><i className="fa fa-exclamation-triangle"/>&nbsp;Требуется подтверждение</small>
                                        </label>
                                        <div className="input-group">
                                            <input type="text" className="form-control" id="account-email" value="+7 (909) 744-9090"
                                                   data-here="masked" data-mask="+9 (999) 999-9999" />
                                            <span className="input-group-btn">
                                    <button type="button" className="btn"
                                            data-toggle="modal" data-target="#confirm-phone-number">Подтвердить</button>
                                </span>
                                        </div>
                                    </fieldset>
                                    <fieldset className="form-group">
                                        <label htmlFor="account-location">Должность</label>
                                        <input type="text" className="form-control" id="account-location" value="Главный по паллетам" />
                                    </fieldset>
                                    <button type="submit" className="btn btn-lg btn-primary m-t-3">Обновить профиль</button>
                                    <a href="#" className="pull-xs-right text-muted p-t-4">Деактивировать учётную запись</a>
                                </div>
                            </form>
                            <div className="m-t-4 visible-xs visible-sm"/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ProfileGeneral;


// WEBPACK FOOTER //
// ./src/pages/Profile/General/ProfileGeneral.js